const MoreIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 47 47"
      fill="none"
    >
      <circle cx="23.5" cy="23.5" r="23.5" fill="white" />
      <path
        d="M43 23.5C43 34.2696 34.2696 43 23.5 43C12.7304 43 4 34.2696 4 23.5C4 12.7304 12.7304 4 23.5 4C34.2696 4 43 12.7304 43 23.5Z"
        fill="white"
      />
      <path
        d="M42.5 23.5C42.5 33.9934 33.9934 42.5 23.5 42.5C13.0066 42.5 4.5 33.9934 4.5 23.5C4.5 13.0066 13.0066 4.5 23.5 4.5C33.9934 4.5 42.5 13.0066 42.5 23.5Z"
        stroke="#35D4AE"
        strokeOpacity="0.2"
      />
      <path
        d="M21 23.5C21 24.8783 22.1217 26 23.5 26C24.8783 26 26 24.8783 26 23.5C26 22.1217 24.8783 21 23.5 21C22.1217 21 21 22.1217 21 23.5Z"
        fill="black"
      />
      <path
        d="M21 32.5C21 33.8783 22.1217 35 23.5 35C24.8783 35 26 33.8783 26 32.5C26 31.1217 24.8783 30 23.5 30C22.1217 30 21 31.1217 21 32.5Z"
        fill="black"
      />
      <path
        d="M21 14.5C21 15.8783 22.1217 17 23.5 17C24.8783 17 26 15.8783 26 14.5C26 13.1217 24.8783 12 23.5 12C22.1217 12 21 13.1217 21 14.5Z"
        fill="black"
      />
    </svg>
  );
};

export default MoreIcon;
